import React from 'react';
import { Link } from 'react-router-dom';
import styled, { keyframes } from 'styled-components';
import CTA from '../assets/CTA.jpg';

// Gradient border animation
const borderGradient = keyframes`
  0% {
    background-position: 0% 50%;
  }
  50% {
    background-position: 100% 50%;
  }
  100% {
    background-position: 0% 50%;
  }
`;

// Gradient text animation
const textGradient = keyframes`
  0% {
    background-position: 0% 50%;
  }
  50% {
    background-position: 100% 50%;
  }
  100% {
    background-position: 0% 50%;
  }
`;

// Styled components
const CTAContainer = styled.section`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 2rem;
  padding: 1rem; /* Reduced from 2rem */
  max-width: 1200px;
  margin: 1.5rem auto; /* Reduced from 4rem */
  position: relative;
  
  &::before {
    content: '';
    position: absolute;
    inset: 0;
    border-radius: 16px;
    padding: 2px;
    background: linear-gradient(45deg, #ff00cc, #3333ff, #00ccff, #ff00cc);
    background-size: 300% 300%;
    -webkit-mask: 
      linear-gradient(#fff 0 0) content-box, 
      linear-gradient(#fff 0 0);
    -webkit-mask-composite: xor;
    mask-composite: exclude;
    animation: ${borderGradient} 8s ease infinite;
    pointer-events: none;
  }
`;

const CTAContent = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 1rem; /* Reduced from 2rem */
  z-index: 1;
`;

const CTAHeading = styled.h2`
  font-size: clamp(2rem, 5vw, 3.5rem);
  font-weight: 800;
  line-height: 1.2;
  margin-bottom: 1rem; /* Reduced from 1.5rem */
  background: linear-gradient(45deg, #ff00cc, #3333ff, #00ccff);
  background-size: 200% 200%;
  -webkit-background-clip: text;
  background-clip: text;
  color: transparent;
  animation: ${textGradient} 6s ease infinite;
`;

const CTASubheading = styled.p`
  font-size: 1.1rem;
  color: rgba(255, 255, 255, 0.8);
  margin-bottom: 1.5rem; /* Reduced from 2rem */
  line-height: 1.6;
`;

const CTAButton = styled(Link)`
  display: inline-block;
  padding: 1rem 2rem;
  background: linear-gradient(45deg, #ff00cc, #3333ff);
  color: white;
  border-radius: 8px;
  font-weight: 600;
  text-decoration: none;
  text-align: center;
  transition: transform 0.3s ease, box-shadow 0.3s ease;
  max-width: 200px;
  
  &:hover {
    transform: translateY(-3px);
    box-shadow: 0 10px 20px rgba(0, 0, 0, 0.2);
  }
`;

const CTAImage = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 1rem; /* Reduced from 2rem */
  
  img {
    max-width: 100%;
    height: auto;
    border-radius: 8px;
    box-shadow: 0 20px 40px rgba(0, 0, 0, 0.3);
  }
`;

// React component
const ModernCTA = () => {
  return (
    <CTAContainer>
      <CTAContent>
        <CTAHeading>Ready to Transform Your Business?</CTAHeading>
        <CTASubheading>
          Join thousands of satisfied customers who have already experienced the power of our solution. 
          Get started today and see the difference for yourself.
        </CTASubheading>
        <CTAButton to="/contact">Get Started</CTAButton>
      </CTAContent>
      <CTAImage>
        <img 
          src={CTA} 
          alt="Modern technology"
        />
      </CTAImage>
    </CTAContainer>
  );
};

export default ModernCTA;